/* eslint-disable no-self-assign */
/* eslint-disable require-yield */

// import get from 'lodash/get'
import companyApi from '@/api/company'
import get from 'lodash/get'

const INITIAL_STATE = {
  dnsRecord: null,
}

export default {
  namespace: 'company',

  state: INITIAL_STATE,

  reducers: {
    setDnsRecord(state, { payload }) {
      return { ...state, dnsRecord: payload }
    },
  },

  effects: {
    *createDomain({ payload, successCallback, errorCallback }, { select, call }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(companyApi.createDomain, {
        data: payload,
        accountId: get(account, 'accountId'),
      })

      const { status } = response

      if (status === 200) {
        successCallback?.()
      } else {
        errorCallback?.()
      }
    },

    *getDNS({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(companyApi.getDNS, {
        accountId: get(account, 'accountId'),
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response

      let hasError = true

      if (status === 200) {
        hasError = false

        yield put({ type: 'company/setDnsRecord', payload: resData.data })

        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },
  },
}
